/* eslint-disable import/prefer-default-export */
import { useState } from "react";

export const useDropdown = (initialState = {}, resetState = {}) => {
  const [values, setValues] = useState(initialState);

  const reset = (reSet = initialState, newStateName = resetState) => {
    if (newStateName) {
      setValues(newStateName);
    } else {
      setValues(reSet);
    }
  };

  const handleDropDownChange = ({ target }) => {
    console.log(target);
    if (target.name && (target.name !== resetState && values[target.name] !== false)) {
      setValues({
        ...values,
        [target.name]: !values[target.name],
        [resetState]: !values[resetState],
      });
    } else if (target.name !== undefined) {
      setValues({
        ...values,
        [target.name]: !values[target.name],
      });
    } else {
      reset();
    }
  };
  return [values, handleDropDownChange, reset];
};
